import axios from "axios";
import { host } from "../option";
import { req, reqAuth } from "@/api/api_request";
import qs from "qs";

function checkUserLogin() {
  return reqAuth.get(`auth/checkUserLogin`);
}

// 获取客户端信息
function getClient(username) {
  return reqAuth.get(
    `anonymous/getClient?appId=58&serverName=${host}&username=${username}`,
    { auth: false }
  );
}

// 获取项目信息信息
function getProjectInfo(projectId) {
  return reqAuth.get(`auth/getProjectInfo?projectId=${projectId}`);
}

// 获取项目名称
function getProjectName() {
  return reqAuth.get(`anonymous/getProjectName?appId=58&serverName=${host}`, {
    auth: false
  });
}

// 登录
function login(data) {
  return reqAuth.post("oauth/token", qs.stringify(data), { auth: false });
}

//referer登录
function refererLogin(params) {
  let url = "/d_web_api/user_manage/loginByReferer";
  return axios.post(url, params);
}

// 获取用户信息
function getAuthUserInfo(proId) {
  return reqAuth.get("auth/getUserInfo?proId=" + proId);
}

// 获取用户信息
function getUserInfo() {
  return req.get("car_api_php/api/yc2/getUserInfo");
}

// 获取用户权限
function getUserMenuPower() {
  let url = `auth/getUserMenuPower?appId=58`;
  return reqAuth.get(url);
}

// 获取项目下用户列表
function getUserListByProjectId(page, size, projectId, userType) {
  let url = `project/userList?pageNo=${page}&pageSize=${size}&projectId=${projectId}&userType=${userType}`;
  return reqAuth.get(url);
}

// 验证口令
function checkKey(key) {
  return axios
    .get(`/a/user_manage/checkKey/?key=${key}`, {
      headers: {
        token: sessionStorage.getItem("10008_yc_token")
      }
    })
    .catch(err => console.log(err));
}

// 修改密码
function passwordChange(data) {
  return axios
    .post(`/a/user_manage/passwordChange/`, data, {
      headers: { token: sessionStorage.getItem("10008_yc_token") }
    })
    .catch(err => console.log(err));
}

export {
  getClient,
  login,
  getProjectInfo,
  getProjectName,
  refererLogin,
  getUserInfo,
  getAuthUserInfo,
  getUserMenuPower,
  getUserListByProjectId,
  checkKey,
  passwordChange,
  checkUserLogin
};
